// extracted by mini-css-extract-plugin
export default {"text_input":"text_input__8eb7dcc9"};